import React from 'react';

import { ContactFlowNodeProps } from '..';
import BaseNode from '../BaseNode';

export default function NoOpNode(props: ContactFlowNodeProps) {
  return <BaseNode {...props} title='No Op' />;
}
